// Versions Controller
// Handles version-related operations

import { post } from './utilitiesController.js';

/**
 * Get versions for a specific element
 * @param {Object} data - Data containing table_name and element_id
 * @returns {Promise} - Response from versions endpoint
 */
export const getElementVersions = async (data) => {
    try {
        // Validate required parameters
        if (!data.table_name || !data.element_id) {
            throw new Error('Missing table_name or element_id');
        }

        // Validate table_name against supported tables
        const supportedTables = [
            'pets',
            'organizations', 
            'incubations',
            'incubation_participants',
            'user_profiles',
            'user_roles',
            'user_access_roles',
            'users'
        ];

        if (!supportedTables.includes(data.table_name)) {
            throw new Error(`Unsupported table_name: ${data.table_name}. Supported tables: ${supportedTables.join(', ')}`);
        }

        const response = await post('api/versions/element', data, true);
        return response;
    } catch (error) {
        console.error('Failed to fetch element versions:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
    }
};

/**
 * Get version summary for a specific element
 * @param {Object} data - Data containing table_name and element_id
 * @returns {Promise} - Response from version summary endpoint
 */
export const getVersionSummary = async (data) => {
    try {
        // Validate required parameters
        if (!data.table_name || !data.element_id) {
            throw new Error('Missing table_name or element_id');
        }

        // Validate table_name against supported tables
        const supportedTables = [
            'pets',
            'organizations', 
            'incubations',
            'incubation_participants',
            'user_profiles',
            'user_roles',
            'user_access_roles',
            'users'
        ];

        if (!supportedTables.includes(data.table_name)) {
            throw new Error(`Unsupported table_name: ${data.table_name}. Supported tables: ${supportedTables.join(', ')}`);
        }

        const response = await post('api/versions/version-summary', data, true);
       console.log('Version summary response:', response);
       
        return response;
    } catch (error) {
        console.error('Failed to fetch version summary:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
    }
};

export default {
    getElementVersions,
    getVersionSummary
};
